__turbopack_context__.v({
  "forceActive": "Button-module__pIC-NW__forceActive",
  "forceHover": "Button-module__pIC-NW__forceHover",
  "root": "Button-module__pIC-NW__root",
});
